import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router, RouterModule, RouterOutlet } from '@angular/router';
import { TnrAuthProviderService } from '@tnr/ng-oauth2';
import { OnePlaceHeaderService } from '@tnr/oneplace-header';
import { WnrNotificationToastModule } from '@wtw/component-library/notification-toast';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { FILL_VIEWPORT_ROUTE_DATA_KEY } from './constants/route-data';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterModule, HeaderComponent, FooterComponent, CommonModule, WnrNotificationToastModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  constructor(
    private readonly oneplaceHeaderService: OnePlaceHeaderService,
    private readonly tnrAuthProviderService: TnrAuthProviderService,
    private readonly router: Router
  ) {}

  isAppReady$: Observable<boolean> = combineLatest([
    this.oneplaceHeaderService.isOnePlaceScriptLoaded$,
    this.tnrAuthProviderService.isDocumentLoadedAndisAuthenticated$
  ]).pipe(map(([isScriptLoaded, isAuthenticated]) => isScriptLoaded && isAuthenticated));

  isFillViewportRoute$: Observable<boolean> = this.router.events.pipe(
    filter((event): event is NavigationEnd => event instanceof NavigationEnd),
    startWith(null),
    map(() => this.hasFillViewportRouteData())
  );

  private hasFillViewportRouteData(): boolean {
    let snapshot: ActivatedRouteSnapshot | null = this.router.routerState.snapshot.root;

    while (snapshot) {
      if (snapshot.data[FILL_VIEWPORT_ROUTE_DATA_KEY] === true) {
        return true;
      }
      snapshot = snapshot.firstChild;
    }

    return false;
  }
}
